module.exports = __webpack_public_path__ + "img/email-icon.a902a46e.svg";